<template>
  <div>
    <div v-if="(!count && tableLoaded && showNoResultTip) || tableLoading" class="noresult">
      <div class="text-center mt-5">
        <lottie v-if="tableLoading" class="avatar-xl" colors="primary:#121331,secondary:#08a88a" :options="defaultOptions"
                :height="75" :width="75" />
        <h5 v-if="!count && tableLoaded && showNoResultTip">{{ tips }}</h5>
        <p class="text-muted">

        </p>
      </div>
    </div>
  </div>
</template>
<script>
import animationData from "@/components/widgets/msoeawqm.json";
import Lottie from "@/components/widgets/lottie.vue";
import i18n from "@/i18n";
export default {
  props: {
    tips: {
      type: String,
      default: i18n.global.t('base.no-data')
    },
    count: {
      type: [Number, String],
      default: 0
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    tableLoaded: {
      type: Boolean,
      default: false,
    },
    showNoResultTip: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData
      },
    }
  },
  components: {
    lottie: Lottie,
  }
}
</script>
